import { render, staticRenderFns } from "./StepsArce.vue?vue&type=template&id=63a61d53&scoped=true&"
import script from "./StepsArce.vue?vue&type=script&lang=js&"
export * from "./StepsArce.vue?vue&type=script&lang=js&"
import style0 from "./StepsArce.vue?vue&type=style&index=0&id=63a61d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a61d53",
  null
  
)

export default component.exports